import Pagination from "@/components/Pagination";

function plugin(Vue) {
  Vue.component('pagination', Pagination)
}

export default plugin
